export default (inputString = '') => {
	const urlPattern = /(https?:\/\/[^\s]+)/g;
	const match = inputString.match(urlPattern);
	let destinationUrl;

	if (match) {
		[destinationUrl] = match;
		const updatedString = inputString.replace(
			urlPattern,
			'destination url'
		);
		return { updatedString, destinationUrl };
	}

	return { updatedString: inputString, destinationUrl };
};
